import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ReportStatus } from '@features/reports/store/reports.interface';

@Component({
  selector: 'xpw-report-status',
  template: `
    <nz-tag [nzColor]="color">
      <xpw-icon [icon]="icon" />
      <span>{{ stringTitle }}</span>
    </nz-tag>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XpwReportStatusTagComponent implements OnChanges {
  @Input() statusId: ReportStatus = null;
  stringTitle: string = '';
  icon: string | null = null;
  color: string = 'default';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['statusId']) {
      this.getData();
    }
  }
  getData() {
    switch (this.statusId) {
      case ReportStatus.Generating:
        this.stringTitle = $localize`Waiting...`;
        this.color = 'default';
        this.icon = 'clock-circle';
        break;
      case ReportStatus.FailedToGenerate:
        this.stringTitle = $localize`Generation Failed`;
        this.color = 'red';
        this.icon = 'failed';
        break;
      case ReportStatus.Delivering:
        this.stringTitle = $localize`Delivering`;

        this.color = 'default';
        this.icon = 'clock-circle';
        break;
      case ReportStatus.FailedToDeliver:
        this.stringTitle = $localize`Delivery Failed`;
        this.color = 'red';
        this.icon = 'failed';
        break;
      case ReportStatus.Delivered:
        this.stringTitle = $localize`Delivered`;
        this.color = 'green';
        this.icon = 'check';
        break;
      case ReportStatus.Partial:
        this.stringTitle = $localize`Partial`;
        this.color = 'orange';
        this.icon = 'warning';
        break;
      default:
        this.stringTitle = $localize`Unknown`;
        break;
    }
  }
}
